
import { translate } from "../Services/translation";
const onhandcheckleadTimeLanguage = (translateprefix,leadtimeVendor,transilation) => {
    //let language=window.__litium.constants.currentLocale;
    if(transilation=="")
    {
        return translate(translateprefix).replace("{0}", leadtimeVendor) ;
    }
    else{
        let trans="";
        if(leadtimeVendor!=null||leadtimeVendor!=undefined)
        {
            trans=leadtimeVendor+" " + translate(transilation);
        }else{
            trans=leadtimeVendor;
        }
        return translate(translateprefix).replace("{0}", trans) ;
    }
  };
  export default onhandcheckleadTimeLanguage;